module.exports = __webpack_public_path__ + "img/icon-remove.b3889e31.svg";